import axios from "axios";

const instance = axios.create({
  //=============  Local server =============
  // baseURL: "http://localhost:4000",

  //=============  Live server =============
  baseURL: "https://gupshup-backend.onrender.com",
});

//for post api call with other methods includes header
// const config = {
//   header: {
//     "Content-type": "application/json",
//   },
// };
// const { data } = await axios.post(
//   "/user/signup",
//   { name, email, password, pic },
//   config
// );
// const userInfo = localStorage.setItem(
//   "userInfo",
//   JSON.stringify(data)
// );
export default instance;
